module.exports = __webpack_public_path__ + "static/media/zhangchi.135fe0bf.png";